<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Base para Cotação de Destinatário",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader,   },
  setup() {

  },
  data() {
    return {
      updating: true,
      errosValid: null,
      freteCotaBaseTabData: {
        id: 0,
        status: 'A'
      },
      freteCotaBaseData: {
        id: 0
      },
      freteCotaBasePesosData: null,
      freteCotaBasePesoData: {},
      freteCotaBaseNotasData: null,
      freteCotaBaseNotaData: {},
      freteCotaBaseExtrasData: null,
      freteCotaBaseExtraData: {},
      idData: 0,
      submitted: false,
      submittedPeso: false,
      submittedNota: false,
      submittedExtra: false,
      title: "Base para Cotação de Destinatário",
      items: [
        {
          text: "Tabelas Base",
          href: "/cotacaofretesbase/list",
        },
        {
          text: "Base para Cotação de Destinatário",
          active: true,
        },
      ],
      showFormPeso: false,
      showFormNota: false,
      showFormExtra: false,

    };
  },

  methods: {


    excluirBase(){
      console.log('excluirBase')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Base de Destinatário",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabase`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Base excluída com sucesso.",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.idData = res.data[0]
              this.$router.replace(`/cotacaofretesbasetab/editar/${this.freteCotaBaseData.fretecotabasetab_id}`)
            })
          })
        }
      })

    },


    abrirTab(){
      console.log('abrirTab')
      const routeData = this.$router.resolve(`/cotacaofretesbasetab/editar/${this.freteCotaBaseTabData.id}`);
      window.open(routeData.href, '_blank')
    },

    abrirFreteTrtTda(){
      console.log('abrirFreteTrtTda')

      const routeData = this.$router.resolve(`/cotacaofretesbasetrttda/list`);
      window.open(routeData.href, '_blank')


    },



    abrirFreteTde(){
      console.log('abrirFreteTde')
      const routeData = this.$router.resolve(`/cotacaofretesbasetde/list`);
      window.open(routeData.href, '_blank')
    },


    copiarBase(){
      console.log('copiarBase')


      Swal.fire({
        position: "center",
        icon: "question",
        title: "Copiar Base de Cotação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.get(`${getBaseUrl()}api/fretecotabasecopiar`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Base copiada com sucesso, encaminhando para nova base",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.idData = res.data[0]
              this.$router.replace(`/cotacaofretesbase/editar/${this.idData}`)
              this.carregarDados()
            })
          })
        }
      })
    },


    confPeso() {
      console.log('confPeso')
      this.submittedPeso = true
      if (this.freteCotaBasePesoData.pesoini && this.freteCotaBasePesoData.pesofim) {

        this.showFormPeso = false
        this.updating = true
        this.freteCotaBasePesoData['fretecotabase_id'] = this.idData
        api.post(`${getBaseUrl()}api/fretecotabasepeso`, {
          freteCotaBasePesoData: this.freteCotaBasePesoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.freteCotaBasePesosData =res.data[0]
            this.updating = false
          })
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    confNota() {
      console.log('confNota')
      this.submittedNota = true
      if (this.freteCotaBaseNotaData.valorininota && this.freteCotaBaseNotaData.valorfimnota){
        this.showFormNota = false
        this.updating = true
        this.freteCotaBaseNotaData['fretecotabase_id'] = this.idData
        api.post(`${getBaseUrl()}api/fretecotabasenota`, {
          freteCotaBaseNotaData: this.freteCotaBaseNotaData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.freteCotaBaseNotasData =res.data[0]
            this.updating = false
          })
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    confExtra() {
      console.log('confExtra')
      this.submittedExtra = true
      if (this.freteCotaBaseExtraData.descricao && this.freteCotaBaseExtraData.subtotal){
        this.showFormExtra = false
        this.updating = true
        this.freteCotaBaseExtraData['fretecotabase_id'] = this.idData
        api.post(`${getBaseUrl()}api/fretecotabaseextra`, {
          freteCotaBaseExtraData: this.freteCotaBaseExtraData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.freteCotaBaseExtrasData =res.data[0]
            this.updating = false
          })
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },


    novoPeso(){
      console.log('novoPeso')
      this.freteCotaBasePesoData = {}
      this.submittedPeso = false
      this.showFormPeso = true
    },

    novaNota(){
      console.log('novaNota')
      this.freteCotaBaseNotaData = {}
      this.submittedNota = false
      this.showFormNota = true
    },

    novaExtra(){
      console.log('novaExtra')
      this.freteCotaBaseExtraData = {}
      this.submittedExtra = false
      this.showFormExtra = true
    },

    editarPeso(data){
      console.log('editarPeso')
      console.log(data)
      this.freteCotaBasePesoData = data
      this.showFormPeso = true
    },

    editarNota(data){
      console.log('editarNota')
      console.log(data)
      this.freteCotaBaseNotaData = data
      this.showFormNota = true
    },

    editarExtra(data){
      console.log('editarExtra')
      console.log(data)
      this.freteCotaBaseExtraData = data
      this.showFormExtra = true
    },


    deletarPeso(dataID){
      console.log('deletarPeso')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Faixa de Peso",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasepeso`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.updating = false
              this.freteCotaBasePesosData = res.data[0]
            })
          })
        }
      })
    },

    deletarNota(dataID){
      console.log('deletarNota')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Faixa de Nota",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasenota`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.updating = false
              this.freteCotaBaseNotasData = res.data[0]
            })
          })
        }
      })
    },

    deletarExtra(dataID){
      console.log('deletarExtra')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Taxa Extra",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabaseextra`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.updating = false
              this.freteCotaBaseExtrasData = res.data[0]
            })
          })
        }
      })
    },

    consultarCEPIni(){
      console.log('consultarCEPIni')


    },

    carregarDados(){
      this.updating = true
      api.get(`${getBaseUrl()}api/fretecotabase`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios cotaFreteBase')
        console.log(res.data)
        this.freteCotaBaseData = res.data[0]
        this.freteCotaBasePesosData = res.data[1]
        this.freteCotaBaseNotasData = res.data[2]
        this.freteCotaBaseExtrasData = res.data[3]
        this.freteCotaBaseTabData = res.data[4]
        this.idData = this.freteCotaBaseData.id
        this.title = `Editar Base de Destinatário (${this.freteCotaBaseData.id}) ${this.freteCotaBaseData.cepini} - ${this.freteCotaBaseData.cepfim}`
        this.updating = false
      });
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;


      if (this.freteCotaBaseData.id === 0) {
        console.log('vai_criar_tabela')
        this.freteCotaBaseData.fretecotabasetab_id = this.$route.query.idtab
      }


      if (this.freteCotaBaseData.cepini && this.freteCotaBaseData.cepfim) {

        this.updating = true
        this.errosValid = []

        api.post(`${getBaseUrl()}api/fretecotabase`, {
          freteCotaBaseData: this.freteCotaBaseData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0){
            this.idData = res.data[0].id
            this.freteCotaBaseData = res.data[0]
            this.$router.replace('/cotacaofretesbase/editar/' + this.idData)
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },



    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_cotacao_frete_editar_0')
    let rota = this.$route.path
    // console.log(this.$route)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Nova Base Destinatário para Cotação de Frete`
      this.updating = false
    }
  },


};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-info" class="mx-2" @click="abrirTab">
                <i class="bx bx-list-check font-size-16 align-middle me-2" ></i>
                Tabela Base
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="formSubmit">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="excluirBase" >
                <i class="bx bx-trash font-size-16 align-middle me-2" ></i>
                Excluir
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoPeso" v-if="freteCotaBaseData.id > 0">
                <i class="bx bx-box font-size-16 align-middle me-2" ></i>
                Nova Faixa de Peso
              </b-button>


              <b-button variant="outline-warning" class="mx-2" @click="novaNota" v-if="freteCotaBaseData.id > 0">
                <i class="bx bx-box font-size-16 align-middle me-2" ></i>
                Nova Faixa de Nota
              </b-button>


              <b-button variant="outline-warning" class="mx-2" @click="novaExtra" v-if="freteCotaBaseData.id > 0">
                <i class="bx bx-box font-size-16 align-middle me-2" ></i>
                Nova Taxa Extra
              </b-button>


<!--              <b-button variant="outline-info" class="mx-2" @click="abrirFreteTde">-->
<!--                <i class="bx bx-list-check font-size-16 align-middle me-2" ></i>-->
<!--                TDE-->
<!--              </b-button>-->



            </div>
          </div>
        </div>
      </div>


      <form class="needs-validation" @submit.prevent="formSubmit">

        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-4
                    class="text-dark"
                    href="javascript: void(0);"
                >Dados Principais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
              <b-card-body>

                <div class="row mb-2">

                  <div class="col-md-2">
                    <label for="cepini">CEP Início</label>
                    <div class="position-relative">
                      <input
                          id="cepini"
                          v-maska="'##.###-###'"
                          type="text"
                          v-model="freteCotaBaseData.cepini"
                          class="form-control"
                          placeholder="CEP"
                          :class="{'is-invalid': submitted && !freteCotaBaseData.cepini}"/>
                      <div v-if="submitted && !freteCotaBaseData.cepini" class="invalid-feedback">
                        <span>Campo CEP obrigatório, favor preencher.</span>
                      </div>
                      <div class="chat-input-links" v-if="freteCotaBaseData.cepini">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a
                                @click="consultarCEPIni"
                                href="javascript: void(0);"
                                v-b-tooltip.hover
                                placement="top"
                                title="Consultar CEP">
                              <i class="mdi mdi-cloud-search-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>


                  <div class="col-md-2">
                    <label for="cepfim">CEP Final</label>
                    <div class="position-relative">
                      <input
                          id="cepfim"
                          v-maska="'##.###-###'"
                          type="text"
                          v-model="freteCotaBaseData.cepfim"
                          class="form-control"
                          placeholder="CEP"
                          :class="{'is-invalid': submitted && !freteCotaBaseData.cepfim}"/>
                      <div v-if="submitted && !freteCotaBaseData.cepfim" class="invalid-feedback">
                        <span>Campo CEP obrigatório, favor preencher.</span>
                      </div>
                      <div class="chat-input-links" v-if="freteCotaBaseData.cepfim">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a
                                @click="consultarCEPIni"
                                href="javascript: void(0);"
                                v-b-tooltip.hover
                                placement="top"
                                title="Consultar CEP">
                              <i class="mdi mdi-cloud-search-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>


                  <div class="col-md-4  ">
                    <label for="cidadefim">Cidade Destino</label>
                    <div class="position-relative">
                      <input
                          id="cidadefim"
                          type="text"
                          v-model="freteCotaBaseData.cidadefim"
                          class="form-control"
                          :class="{'is-invalid': submitted && !freteCotaBaseData.cidadefim}"
                          placeholder="Cidade Destino"/>
                      <div v-if="submitted && !freteCotaBaseData.cidadefim" class="invalid-feedback">
                        <span>Campo Cidade Destino obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="estadofim">Estado Destino</label>
                    <div class="position-relative">
                      <input
                          id="estadofim"
                          type="text"
                          v-model="freteCotaBaseData.estadofim"
                          class="form-control"
                          :class="{'is-invalid': submitted && !freteCotaBaseData.estadofim}"
                          placeholder="Estado Destino"/>
                      <div v-if="submitted && !freteCotaBaseData.estadofim" class="invalid-feedback">
                        <span>Campo Cidade Destino obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="prazo">Prazo (Dias Úteis)</label>
                    <div class="position-relative">
                      <input
                          id="prazo"
                          type="number"
                          v-model="freteCotaBaseData.prazo"
                          class="form-control text-end"
                          placeholder="Prazo (Dias Úteis)"/>
                    </div>
                  </div>



                </div>

                <div class="row mb-2">

                  <div class="col-md-2">
                    <label for="vlricms">Valor ICMS</label>
                    <div class="position-relative">
                      <input
                          id="vlricms"
                          type="number"
                          v-model="freteCotaBaseData.vlricms"
                          class="form-control text-end"
                          placeholder="Valor ICMS"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="cubft">Fator de Cubagem</label>
                    <div class="position-relative">
                      <input
                          id="cubft"
                          type="number"
                          v-model="freteCotaBaseData.cubft"
                          class="form-control text-end"
                          placeholder="Fator de Cubagem"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="valminsub8">Val.Mín.Sub.8</label>
                    <div class="position-relative">
                      <input
                          id="valminsub8"
                          type="number"
                          v-model="freteCotaBaseData.valminsub8"
                          class="form-control text-end"
                          placeholder="Valor Mínimo SubTotal 8"/>
                    </div>
                  </div>

                </div>



              </b-card-body>

            </b-collapse>
          </div>
        </div>


        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">

              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-3
                      class="text-dark"
                      href="javascript: void(0);"
                  >Faixa(s) de Seleção PESO</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                <b-card-body>

                  <div class="row mb-3">

                    <div class="col-md-4">
                      <label for="pesoexcedvlr">Valor Peso Excedente (R$)</label>
                      <div class="position-relative">
                        <input
                            id="pesoexcedvlr"
                            type="number"
                            v-model="freteCotaBaseData.pesoexcedvlr"
                            class="form-control text-end"
                            placeholder="Valor Peso Excedente"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="pesoadicvlr">Valor Peso Adicional (R$)</label>
                      <div class="position-relative">
                        <input
                            id="pesoadicvlr"
                            type="number"
                            v-model="freteCotaBaseData.pesoadicvlr"
                            class="form-control text-end"
                            placeholder="Valor Peso Adicional (R$)"/>
                      </div>
                    </div>

                  </div>


                  <div class="row mb-4">

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col" class="text-end">Peso Inicial</th>
                          <th scope="col" class="text-end">Peso Final</th>
                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Tx.Fx.Até x KG</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in freteCotaBasePesosData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarPeso(data)">
                                  <span class="text-dark">
                                    {{ data.id }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.pesoini) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.pesofim) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valor) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.vlrfixokg) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarPeso(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarPeso(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>


                </b-card-body>

              </b-collapse>
            </div>
          </div>


          <div class="card col-md-6">

            <div class="card-body">

              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-6
                      class="text-dark"
                      href="javascript: void(0);"
                  >Faixa(s) de Seleção NOTAS FISCAIS</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                <b-card-body>

                  <div class="row mb-3">

                    <div class="col-md-4">
                      <label for="valorexcenota">Valor Excedente Nota (R$)</label>
                      <div class="position-relative">
                        <input
                            id="valorexcenota"
                            type="number"
                            v-model="freteCotaBaseData.valorexcenota"
                            class="form-control text-end"
                            placeholder="Valor Excedente Nota (R$)"/>
                      </div>
                    </div>

                  </div>


                  <div class="row mb-4">

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col" class="text-end">Valor Inicial</th>
                          <th scope="col" class="text-end">Valor Final</th>
                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in freteCotaBaseNotasData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarNota(data)">
                                  <span class="text-dark">
                                    {{ data.id }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valorininota) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valorfimnota) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valor) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarNota(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarNota(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>


                </b-card-body>

              </b-collapse>
            </div>

          </div>

        </div>



        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-1
                    class="text-dark"
                    href="javascript: void(0);"
                >Tabela de Frete por Comparação (FQM)</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
              <b-card-body>

                <div class="row mb-3">

                  <div class="col-md-2">
                    <label for="compfretemin">Frete Mínimo</label>
                    <div class="position-relative">
                      <input
                          id="compfretemin"
                          type="number"
                          v-model="freteCotaBaseData.compfretemin"
                          class="form-control tex-end"
                          placeholder="Frete Mínimo"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="compercnota">Percentual Sobre Nota</label>
                    <div class="position-relative">
                      <input
                          id="compercnota"
                          type="number"
                          v-model="freteCotaBaseData.compercnota"
                          class="form-control text-end"
                          placeholder="Percentual Sobre Nota"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="compvlrkg">Valor por KG</label>
                    <div class="position-relative">
                      <input
                          id="compvlrkg"
                          type="number"
                          v-model="freteCotaBaseData.compvlrkg"
                          class="form-control text-end"
                          placeholder="Valor por KG"/>
                    </div>
                  </div>

                </div>

              </b-card-body>
            </b-collapse>
          </div>
        </div>




        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-2
                    class="text-dark"
                    href="javascript: void(0);"
                >Variáveis para Composição de Valor</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
              <b-card-body>

                <div class="row mb-3">

                  <div class="col-md-2">
                    <label for="fretevlrpercnota">Frete Porcentagem Nota (%)</label>
                    <div class="position-relative">
                      <input
                          id="fretevlrpercnota"
                          type="number"
                          v-model="freteCotaBaseData.fretevlrpercnota"
                          class="form-control text-end"
                          placeholder="Frete Porcentagem Nota (%)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="fretevlrmin">Frete Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="fretevlrmin"
                          type="number"
                          v-model="freteCotaBaseData.fretevlrmin"
                          class="form-control text-end"
                          placeholder="Frete Valor Mínimo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="grispercnota">GRIS Porcentagem Nota (%)</label>
                    <div class="position-relative">
                      <input
                          id="grispercnota"
                          type="number"
                          v-model="freteCotaBaseData.grispercnota"
                          class="form-control text-end"
                          placeholder="GRIS Porcentagem Nota (%)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="grisvlrmin">GRIS Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="grisvlrmin"
                          type="number"
                          v-model="freteCotaBaseData.grisvlrmin"
                          class="form-control text-end"
                          placeholder="GRIS Valor Mínimo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="txsegobrigperc">Taxa Seguro Obrig. Perc. Nota</label>
                    <div class="position-relative">
                      <input
                          id="txsegobrigperc"
                          type="number"
                          v-model="freteCotaBaseData.txsegobrigperc"
                          class="form-control text-end"
                          placeholder="Taxa Seguro Obrig. Perc. Nota"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="txsegobrigperc">Taxa Seguro Obrig. Vlr.Min.</label>
                    <div class="position-relative">
                      <input
                          id="txsegobrigvlrmin"
                          type="number"
                          v-model="freteCotaBaseData.txsegobrigvlrmin"
                          class="form-control text-end"
                          placeholder="Taxa Seguro Obrig. Vlr.Min."/>
                    </div>
                  </div>




                </div>



                <div class="row mb-3">

                  <div class="col-md-2">
                    <label for="tasvlrfixo">TAS Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="tasvlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.tasvlrfixo"
                          class="form-control text-end"
                          placeholder="TAS Valor Fixo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="despachovlrfixo">Despachante Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="despachovlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.despachovlrfixo"
                          class="form-control text-end"
                          placeholder="Despachante Valor Fixo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="admrodopercfrete">Adm. Rodo. Frete Final (%)</label>
                    <div class="position-relative">
                      <input
                          id="admrodopercfrete"
                          type="number"
                          v-model="freteCotaBaseData.admrodopercfrete"
                          class="form-control text-end"
                          placeholder="Adm. Rodo. Frete Final (%)"/>
                    </div>
                  </div>

                </div>


                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="tsbpercnota">TSB Porcentagem Nota (%)</label>
                    <div class="position-relative">
                      <input
                          id="tsbpercnota"
                          type="number"
                          v-model="freteCotaBaseData.tsbpercnota"
                          class="form-control text-end"
                          placeholder="TSB Porcentagem Nota (%)"/>
                    </div>
                  </div>



                  <div class="col-md-2">
                    <label for="tsbvlrmin">TSB Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="tsbvlrmin"
                          type="number"
                          v-model="freteCotaBaseData.tsbvlrmin"
                          class="form-control text-end"
                          placeholder="TSB Valor Mínimo (R$)"/>
                    </div>
                  </div>


                  <div class="col-md-2">
                    <label for="tsbvlrmax">TSB Valor Máximo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="tsbvlrmax"
                          type="number"
                          v-model="freteCotaBaseData.tsbvlrmax"
                          class="form-control text-end"
                          placeholder="TSB Valor Máximo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="tsbvlrfixo">TSB Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="tsbvlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.tsbvlrfixo"
                          class="form-control text-end"
                          placeholder="TSB Valor Fixo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="suframavlrfixo">Suframa Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="suframavlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.suframavlrfixo"
                          class="form-control text-end"
                          placeholder="Suframa Valor Fixo (R$)"/>
                    </div>
                  </div>


                </div>


                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="segfluvperc">Seg.Fluvial Porcentagem Nota (%)</label>
                    <div class="position-relative">
                      <input
                          id="segfluvperc"
                          type="number"
                          v-model="freteCotaBaseData.segfluvperc"
                          class="form-control text-end"
                          placeholder="Seg.Fluvial Porcentagem Nota (%)"/>
                    </div>
                  </div>



                  <div class="col-md-2">
                    <label for="segfluvvlrmin">Seg.Fluvial Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="segfluvvlrmin"
                          type="number"
                          v-model="freteCotaBaseData.segfluvvlrmin"
                          class="form-control text-end"
                          placeholder="Seg.Fluvial Valor Mínimo (R$)"/>
                    </div>
                  </div>


                  <div class="col-md-2">
                    <label for="segfluvvlrmax">Seg.Fluvial Valor Máximo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="segfluvvlrmax"
                          type="number"
                          v-model="freteCotaBaseData.segfluvvlrmax"
                          class="form-control text-end"
                          placeholder="Seg.Fluvial Valor Máximo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="segfluvvlrfixo">Seg.Fluvial Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="segfluvvlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.segfluvvlrfixo"
                          class="form-control text-end"
                          placeholder="Seg.Fluvial Valor Fixo (R$)"/>
                    </div>
                  </div>



                </div>


                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="pedagiovlrfixo">Pedágio Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="pedagiovlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.pedagiovlrfixo"
                          class="form-control text-end"
                          placeholder="Pedágio Valor Fixo (R$)"/>
                    </div>
                  </div>



                  <div class="col-md-2">
                    <label for="pedagiofrac100kg">Pedágio Fração a cada 100kg (R$)</label>
                    <div class="position-relative">
                      <input
                          id="pedagiofrac100kg"
                          type="number"
                          v-model="freteCotaBaseData.pedagiofrac100kg"
                          class="form-control text-end"
                          placeholder="Pedágio Fração a cada 100kg (R$)"/>
                    </div>
                  </div>


                  <div class="col-md-2">
                    <label for="pedagiovlrkg">Pedágio por KG (R$)</label>
                    <div class="position-relative">
                      <input
                          id="pedagiovlrkg"
                          type="number"
                          v-model="freteCotaBaseData.pedagiovlrkg"
                          class="form-control text-end"
                          placeholder="Pedágio por KG (R$)"/>
                    </div>
                  </div>



                </div>



                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="coletavlrfixo">Coleta Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="coletavlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.coletavlrfixo"
                          class="form-control text-end"
                          placeholder="Coleta Valor Fixo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="coletavlrkg">Coleta Valor KG (R$)</label>
                    <div class="position-relative">
                      <input
                          id="coletavlrkg"
                          type="number"
                          v-model="freteCotaBaseData.coletavlrkg"
                          class="form-control text-end"
                          placeholder="Coleta Valor KG (R$)"/>
                    </div>
                  </div>


                  <div class="col-md-2">
                    <label for="entregavlrfixo">Entrega Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="entregavlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.entregavlrfixo"
                          class="form-control text-end"
                          placeholder="Entrega Valor Fixo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="entregavlrkg">Entrega Valor KG (R$)</label>
                    <div class="position-relative">
                      <input
                          id="coletavlrkg"
                          type="number"
                          v-model="freteCotaBaseData.entregavlrkg"
                          class="form-control text-end"
                          placeholder="Entrega Valor KG (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="seccatvlrfixo">SECCAT Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="seccatvlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.seccatvlrfixo"
                          class="form-control text-end"
                          placeholder="SECCAT Valor Fixo (R$)"/>
                    </div>
                  </div>

                </div>

              </b-card-body>
            </b-collapse>
          </div>
        </div>






        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-5
                    class="text-dark"
                    href="javascript: void(0);"
                >Variáveis Adicionais para Composição de Valor</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
              <b-card-body>

                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="ademeperc">ADEME Porcentagem Nota (%)</label>
                    <div class="position-relative">
                      <input
                          id="ademeperc"
                          type="number"
                          v-model="freteCotaBaseData.ademeperc"
                          class="form-control text-end"
                          placeholder="ADEME Porcentagem Nota (%)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="ademevlrmin">ADEME Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="ademevlrmin"
                          type="number"
                          v-model="freteCotaBaseData.ademevlrmin"
                          class="form-control text-end"
                          placeholder="ADEME Valor Mínimo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="ademevlrmax">ADEME Valor Máximo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="ademevlrmax"
                          type="number"
                          v-model="freteCotaBaseData.ademevlrmax"
                          class="form-control text-end"
                          placeholder="ADEME Valor Máximo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="ademevlrfixo">ADEME Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="ademevlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.ademevlrfixo"
                          class="form-control text-end"
                          placeholder="ADEME Valor Fixo (R$)"/>
                    </div>
                  </div>



                </div>




                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="emexperc">EMEX Porcentagem Nota (%)</label>
                    <div class="position-relative">
                      <input
                          id="emexperc"
                          type="number"
                          v-model="freteCotaBaseData.emexperc"
                          class="form-control text-end"
                          placeholder="EMEX Porcentagem Nota (%)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="emexvlrmin">EMEX Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="emexvlrmin"
                          type="number"
                          v-model="freteCotaBaseData.emexvlrmin"
                          class="form-control text-end"
                          placeholder="EMEX Valor Mínimo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="emexvlrmax">EMEX Valor Máximo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="emexvlrmax"
                          type="number"
                          v-model="freteCotaBaseData.emexvlrmax"
                          class="form-control text-end"
                          placeholder="EMEX Valor Máximo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="emexvlrfixo">EMEX Valor Fixo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="emexvlrfixo"
                          type="number"
                          v-model="freteCotaBaseData.emexvlrfixo"
                          class="form-control text-end"
                          placeholder="EMEX Valor Fixo (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="emexfrac100kg">EMEX Fração 100kg (R$)</label>
                    <div class="position-relative">
                      <input
                          id="emexfrac100kg"
                          type="number"
                          v-model="freteCotaBaseData.emexfrac100kg"
                          class="form-control text-end"
                          placeholder="EMEX Fração 100kg (R$)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="emexvlrkg">EMEX por KG (R$)</label>
                    <div class="position-relative">
                      <input
                          id="emexvlrkg"
                          type="number"
                          v-model="freteCotaBaseData.emexvlrkg"
                          class="form-control text-end"
                          placeholder="EMEX por KG (R$)"/>
                    </div>
                  </div>



                </div>



                <div class="row mb-3">


                  <div class="col-md-2">
                    <label for="txagendperc">Taxa Agendamento (%)</label>
                    <div class="position-relative">
                      <input
                          id="txagendperc"
                          type="number"
                          v-model="freteCotaBaseData.txagendperc"
                          class="form-control text-end"
                          placeholder="Taxa Agendamento (%)"/>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="txagendvlrmin">Tx. Agend. Valor Mínimo (R$)</label>
                    <div class="position-relative">
                      <input
                          id="txagendvlrmin"
                          type="number"
                          v-model="freteCotaBaseData.txagendvlrmin"
                          class="form-control text-end"
                          placeholder="Taxa Agendamento Valor Mínimo (R$)"/>
                    </div>
                  </div>

                </div>


              </b-card-body>
            </b-collapse>
          </div>
        </div>



        <div class="row">
          <div class="card col-md-12">
            <div class="card-body">

              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-7
                      class="text-dark"
                      href="javascript: void(0);"
                  >Taxas Extras</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-7" visible accordion="my-accordion-7" role="tabpanel">
                <b-card-body>


                  <div class="row mb-4">

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Subtotal</th>
                          <th scope="col" class="text-end">Valor KG</th>
                          <th scope="col" class="text-end">Valor Mín</th>
                          <th scope="col" class="text-end">Valor Max</th>
                          <th scope="col" class="text-end">Valor Fixo</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in freteCotaBaseExtrasData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarPeso(data)">
                                  <span class="text-dark">
                                    {{ data.id }}
                                  </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.descricao }}
                                  </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.subtotal }}
                                  </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valorkg) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valormin) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valormax) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.valorfixo) }}
                                  </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarExtra(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarExtra(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>


                </b-card-body>

              </b-collapse>
            </div>
          </div>




        </div>





      </form>

    </div>




    <b-modal  size="lg"
              :title="freteCotaBasePesoData.id > 0 ? 'Editando Faixa de Peso Base de Cálculo ' + freteCotaBasePesoData.id : 'Criando Faixa de Peso Base de Cálculo'"
              v-model="showFormPeso" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">


              <div class="row mb-3">


                  <div class="col-md-4">
                    <label for="pesoini">Faixa Peso Inicial (KG)</label>
                    <div class="position-relative">
                      <input
                          id="pesoini"
                          type="number"
                          v-model="freteCotaBasePesoData.pesoini"
                          class="form-control text-end"
                          :class="{'is-invalid': submittedPeso && !freteCotaBasePesoData.pesoini}"
                          placeholder="Faixa Peso Inicial (KG)"/>
                      <div v-if="submittedPeso && !freteCotaBaseData.pesoini" class="invalid-feedback">
                        <span>Campo Peso Inicial obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label for="pesofim">Faixa Peso Final (KG)</label>
                    <div class="position-relative">
                      <input
                          id="pesofim"
                          type="number"
                          v-model="freteCotaBasePesoData.pesofim"
                          class="form-control text-end"
                          :class="{'is-invalid': submittedPeso && !freteCotaBasePesoData.pesofim}"
                          placeholder="Faixa Peso Final (KG)"/>
                      <div v-if="submittedPeso && !freteCotaBaseData.pesofim" class="invalid-feedback">
                        <span>Campo Peso Final obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label for="valor">Valor (R$)</label>
                    <div class="position-relative">
                      <input
                          id="valor"
                          type="number"
                          v-model="freteCotaBasePesoData.valor"
                          class="form-control text-end"
                          :class="{'is-invalid': submittedPeso && !freteCotaBasePesoData.valor}"
                          placeholder="Valor (R$)"/>
                      <div v-if="submittedPeso && !freteCotaBaseData.valor" class="invalid-feedback">
                        <span>Campo Valor obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

              </div>

              <div class="row mb-3">

                <div class="col-md-4">
                  <label for="vlrfixokg">Taxa Fixa Até x KG</label>
                  <div class="position-relative">
                    <input
                        id="vlrfixokg"
                        type="number"
                        v-model="freteCotaBasePesoData.vlrfixokg"
                        class="form-control text-end"
                        placeholder="Taxa Fixa Até x KG"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <label for="vlrporkg">Taxa por KG até x KG</label>
                  <div class="position-relative">
                    <input
                        id="vlrporkg"
                        type="number"
                        v-model="freteCotaBasePesoData.vlrporkg"
                        class="form-control text-end"
                        placeholder="Taxa por KG até x KG"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <label for="vlrporkgmin">Taxa por KG Mín. até x KG</label>
                  <div class="position-relative">
                    <input
                        id="vlrporkgmin"
                        type="number"
                        v-model="freteCotaBasePesoData.vlrporkgmin"
                        class="form-control text-end"
                        placeholder="Taxa por KG Mín. até x KG"/>
                  </div>
                </div>

              </div>


              <div class="row mb-3">

                <div class="col-md-4">
                  <label for="vlrperckg">Valor % até x KG</label>
                  <div class="position-relative">
                    <input
                        id="vlrperckg"
                        type="number"
                        v-model="freteCotaBasePesoData.vlrperckg"
                        class="form-control text-end"
                        placeholder="Valor % até x KG"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <label for="vlrperckgmin">Valor % Mín. até x KG</label>
                  <div class="position-relative">
                    <input
                        id="vlrperckgmin"
                        type="number"
                        v-model="freteCotaBasePesoData.vlrperckgmin"
                        class="form-control text-end"
                        placeholder="Valor % Mín. até x KG"/>
                  </div>
                </div>


              </div>



              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormPeso = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confPeso">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal  size="lg"
              :title="freteCotaBaseNotaData.id > 0 ? 'Editando Faixa de Nota Base de Cálculo ' + freteCotaBaseNotaData.id : 'Criando Faixa de Nota Base de Cálculo'"
              v-model="showFormNota" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row mb-3">

                  <div class="col-md-4">
                    <label for="valorininota">Faixa Valor Inicial (R$)</label>
                    <div class="position-relative">
                      <input
                          id="valorininota"
                          type="number"
                          v-model="freteCotaBaseNotaData.valorininota"
                          class="form-control text-end"
                          :class="{'is-invalid': submittedNota && !freteCotaBaseNotaData.valorininota}"
                          placeholder="Faixa Valor Inicial (R$)"/>
                      <div v-if="submittedNota && !freteCotaBaseNotaData.valorininota" class="invalid-feedback">
                        <span>Campo Valor Inicial obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label for="valorfimnota">Faixa Valor Final (R$)</label>
                    <div class="position-relative">
                      <input
                          id="valorfimnota"
                          type="number"
                          v-model="freteCotaBaseNotaData.valorfimnota"
                          class="form-control text-end"
                          :class="{'is-invalid': submittedNota && !freteCotaBaseNotaData.valorfimnota}"
                          placeholder="Faixa Valor Final (R$)"/>
                      <div v-if="submittedNota && !freteCotaBaseNotaData.valorfimnota" class="invalid-feedback">
                        <span>Campo Valor Final obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label for="valor">Valor (R$)</label>
                    <div class="position-relative">
                      <input
                          id="valor"
                          type="number"
                          v-model="freteCotaBaseNotaData.valor"
                          class="form-control text-end"
                          :class="{'is-invalid': submittedNota && !freteCotaBaseNotaData.valor}"
                          placeholder="Valor (R$)"/>
                      <div v-if="submittedNota && !freteCotaBaseNotaData.valor" class="invalid-feedback">
                        <span>Campo Valor obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

              </div>


              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormNota = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confNota">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal  size="lg"
              :title="freteCotaBaseExtraData.id > 0 ? 'Editando Taxa Extra Base de Cálculo ' + freteCotaBaseExtraData.id : 'Criando Taxa Extra Base de Cálculo'"
              v-model="showFormExtra" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row mb-3">

                  <div class="col-md-9">
                    <label for="descricao">Descrição</label>
                    <div class="position-relative">
                      <input
                          id="descricao"
                          type="text"
                          v-model="freteCotaBaseExtraData.descricao"
                          class="form-control"
                          :class="{'is-invalid': submittedExtra && !freteCotaBaseExtraData.descricao}"
                          placeholder="Descrição"/>
                      <div v-if="submittedExtra && !freteCotaBaseExtraData.descricao" class="invalid-feedback">
                        <span>Campo Descrição obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>


                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="subtotal">Sub Total</label>
                      <select
                          id="subtotal"
                          v-model="freteCotaBaseExtraData.subtotal"
                          class="form-control"
                          :class="{'is-invalid': submittedExtra && !freteCotaBaseExtraData.subtotal}">
                        <option value="1">SubTotal 1</option>
                        <option value="2">SubTotal 2</option>
                        <option value="3">SubTotal 3</option>
                        <option value="4">SubTotal 4</option>
                      </select>
                      <div v-if="submittedExtra && !freteCotaBaseExtraData.subtotal" class="invalid-feedback">
                        <span>Campo SubTotal obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>


              </div>

              <div class="row mb-3">

                <div class="col-md-3">
                  <label for="valorkg">Valor KG</label>
                  <div class="position-relative">
                    <input
                        id="valorkg"
                        type="number"
                        v-model="freteCotaBaseExtraData.valorkg"
                        class="form-control text-end"
                        placeholder="Valor KG"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="valormin">Valor Mínimo</label>
                  <div class="position-relative">
                    <input
                        id="valormin"
                        type="number"
                        v-model="freteCotaBaseExtraData.valormin"
                        class="form-control text-end"
                        placeholder="Valor Mínimo"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="valormax">Valor Máximo</label>
                  <div class="position-relative">
                    <input
                        id="valormax"
                        type="number"
                        v-model="freteCotaBaseExtraData.valormax"
                        class="form-control text-end"
                        placeholder="Valor Máximo"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <label for="valorfixo">Valor Fixo</label>
                  <div class="position-relative">
                    <input
                        id="valorfixo"
                        type="number"
                        v-model="freteCotaBaseExtraData.valorfixo"
                        class="form-control text-end"
                        placeholder="Valor Fixo"/>
                  </div>
                </div>

              </div>


              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormExtra = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confExtra">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>







  </Layout>
</template>
